export const trimTrailingSlashes = (url: string) =>
  url.replace(new RegExp('/+$'), '');
